import { jsx as _jsx } from "react/jsx-runtime";
import { FaExpand } from 'react-icons/fa';
import { Toolbar } from '../toolbar/Toolbar';
import { useFullscreen } from './FullscreenContext';
export function FullscreenToolbarButton() {
    const { toggle } = useFullscreen();
    return (_jsx(Toolbar.Item, { title: "Full screen", onClick: toggle, children: _jsx(FaExpand, {}) }));
}
//# sourceMappingURL=FullscreenToolbarButton.js.map